<template>
  <div>
    <el-table
      border
      stripe
      :data="tableData"
      style="width: 100%;"
      :row-style="{height:'40px'}"
      size="mini"
      v-loading="listLoading"
      :header-cell-style="{background:'#D7D7D7',color:'#000'}"
      :cell-class-name="cellCss"
      :cell-style="{'white-space': 'pre'}"
      row-key="id"
    >
      <el-table-column v-if="withIndex" type="index" width="45" align="center"></el-table-column>

      <ElementCratorTable v-for="c in config" :key="c.hash" :config="c" />
      <div slot="empty">
        <span class="list-table-empty-text">{{emptyInfo}}</span>
      </div>
    </el-table>
    <slot name="pagination"></slot>
  </div>
</template>

<script>
// import BillHistory from './BillHistory'
// import ColumnStockDropDown from './ColumnStockDropDown'
// import ColumnAddToCart from './ColumnAddToCart'
import { mapState, mapGetters } from 'vuex'

import ElementCratorTable from './ElementCratorTable'

export default {
  name: 'SearchResults',
  components: {
    ElementCratorTable
  },
  computed: {
    ...mapState('search', {
      listLoading: 'listLoading',
      tableData: 'lists',
      isNewEnter: 'isNew',
      withIndex: 'withIndex'
    }),
    ...mapState('config', {
      config: 'lines'
    }),
    ...mapGetters({
      cellCss: 'prefs/searchInvCellClass'
    }),
    emptyInfo () {
      return this.isNewEnter ? 'Enter Some Key Words to Search' : 'No Data'
    }
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
.el-divider {
  margin: 8px 0;
  background-color: #eff2f8;
}
</style>
